export default {
	name: "indexView",
	data() {
		return {
			breadcrumb: '列表',
			list: [],
			suggest: []
		};
	},
	props: ['group'],
	watch: {},
	created() {},
	mounted() {
		this.breadcrumb = this.group.group_name;
		this.getList();
		this.getSuggest();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getList() {
			const listRes = await this.$zkHttp.index$getStudenArticle({
				page: 1,
				limit: 100,
				group_id: this.group.group_id
			});
			console.log("listRes", listRes);
			this.list = listRes;
		},
		async getSuggest() {
			const suggestRes = await this.$zkHttp.index$getSuggestArticle();
			console.log("suggestRes", suggestRes);
			this.suggest = suggestRes;
		},
		gotoStDetail(id) {
			this.$router.push({
				name: 'studentDetail',
				query: {
					group: this.group,
					articleId: id
				}
			});
		}
	},
};